import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/network-service.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "network-service"
    }}>{`Network Service`}</h1>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`NetworkService`}</inlineCode>{` provides shared functionality to make asynchronous network requests and handle their responses.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`The following code snippet details how to make a simple network request and handle the response.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=usage" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=usage" mdxType="Tabs" />
    <h2 {...{
      "id": "overriding-networkservice"
    }}>{`Overriding NetworkService`}</h2>
    <p>{`The default implementation of the `}<inlineCode parentName="p">{`NetworkService`}</inlineCode>{` provided by the SDK can be overriden to use a custom implementation to cater to your app requirements. This section walks through the steps necessary to create a custom network override, and register it with the SDK.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=override" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=override" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      